/**
 * Single source of truth for myoddschecker URL construction.
 *
 * OC is served without a repub prefix (`/myoddschecker/...`); every other repub is prefixed
 * (`/{repub}/myoddschecker/...`). This rule was previously duplicated inline across the myoddschecker
 * app (TabNav, MiniMyOC, index-page redirects) and the atlas-astro header account menu — keep it here
 * (beside `getRepubHomeUrl` / `getRepubMetaFromRepub`) so adding/relocating a myoddschecker route is a
 * one-line change with one source of truth across packages and apps. The myoddschecker
 * session/logout endpoints (NGF-6477) live under this namespace, so cross-package callers (the auth
 * feature, the login widget, the onboarding store) construct their paths from this helper too.
 *
 * Accepts `repub` as a plain string (callers hold it in either case) and lowercases it.
 *
 * Note WS's myoddschecker URLs are unreachable in production (whoscored.com's edge only forwards
 * `/plus*` and `/api/*` to cx-web, and the myoddschecker app is not served behind that domain) —
 * which is why WS logout does NOT go through this helper: `logout()` in `@cx-web/feature-auth`
 * branches WS to product-plus's `/plus/auth/logout` instead (SPOR-2292). The WS branch must NOT
 * live here: this helper's other consumers append non-logout segments (`/profile`, `/settings`),
 * and an auth-tree base would resolve those onto the `:provider` SSO route as a confusing 405.
 */
export function getMyOcBasePath(repub: string): string {
  const r = repub.toLowerCase();
  return r === 'oc' ? '/myoddschecker' : `/${r}/myoddschecker`;
}
